import React, { useRef } from "react";
import TheMallOutletLayout from "../../../layouts/TheMallOutletLayout/TheMallOutletLayout";
import HeadPage from "../../../components/HeadPage/HeadPage";
import WrapperDetail from "../../../components/WrapperDetail/WrapperDetail";
import { fetchData } from "../../../fetcher";
import styles from "../../../styles/pages/specific-event.module.scss";
import ImageCarousel from "../../../components/ImageCarousel/ImageCarousel";
import CardCarousel from "../../../components/CardCarousel/CardCarousel";
import Accordion from "../../../components/Accordion/Accordion";
import ScrollDown from "../../../components/ScrollDown/ScrollDown";
import GolfForm from "../../../components/GolfForm/GolfForm";
import SwipeCalendar from "../../../components/SwipeCalendar/SwipeCalendar";
import { useRouter } from "next/dist/client/router";
import EventExtra from "../../../components/EventExtra/EventExtra";


const EventDetailPage = ({ menuItems, dataContent, slug, properties }) => {
  const scrollToRef = useRef(null);
  let router = useRouter();

  return (
    <TheMallOutletLayout menuItems={menuItems}>
      {dataContent.event.isextra && <EventExtra event={dataContent.event} properties={properties} />}
      {!dataContent.event.isextra && <>
      <div id="head" ref={scrollToRef}>
        <HeadPage {...dataContent?.head} />
      </div>
      <div
        className={`centeredSection ${styles.WrapperDetail}`}
        style={{
          position: dataContent.event.card.pastEvent ? "unset" : null,
          marginBottom: dataContent.event.card.pastEvent ? "6.625rem" : null,
        }}
      >
        <WrapperDetail
          leftContent={dataContent.event.card.leftContent}
          rightContent={dataContent.event.card.rightContent}
          event
          pastEvent={dataContent.event.card.pastEvent}
        />
        {(router.query.locale == 'it' || router.query.locale == 'en' || router.query.locale == 'fr') && slug == '/events/the-mall-firenze-golf-cup-2023' && <div>
          <GolfForm properties={properties} />
        </div>}
      </div>
      {dataContent.event.calendar && dataContent.event.calendar.items.length && <div>
        <SwipeCalendar items={dataContent.event.calendar.items} />
      </div>}
      {!dataContent.event?.card?.pastEvent && dataContent.event?.accordion?.items?.length > 0 && (
        <div className={`smallerCenteredSection ${styles.Accordion}`}>
          <Accordion
            title={dataContent.event.accordion.title}
            items={dataContent.event.accordion.items}
            bookTitle={dataContent.event.card.rightContent.contacts.bookTitle}
            links={dataContent.event.card.rightContent.contacts.links}
            fullscreen
          />
        </div>
      )}
      <div className={styles.ImageCarousel}>
        <ImageCarousel
          items={dataContent?.event?.carousel?.items}
          title={dataContent?.event?.carousel?.title}
          bigSlides={true}
        />
      </div>
      <div className={styles.CardCarousel}>
        <CardCarousel
          listOfBrands={dataContent.eventCarousel.items}
          goldTitle={dataContent.eventCarousel.goldTitle}
          more={dataContent.eventCarousel.more}
          hoverText={dataContent.eventCarousel.hoverText}
          autoplay={false}
        />
      </div>
      <div className="scroll">
        <ScrollDown selector={scrollToRef} scrollTop />
      </div>
      </>}
      
    </TheMallOutletLayout>
  );
};

EventDetailPage.getInitialProps = async (context) => {
  let menuItems = null;
  let dataContent = null;
  const { slug } = context.query;

  const resmenu = await fetchData("/init", context.query.locale);
  const data = await fetchData(slug, context.query.locale);
  const resproperties = await fetchData(null, context.query.locale, 'GET', null, null, null, true);
//console.log(slug, context.query.locale, data);
  if (resmenu) {
    menuItems = resmenu.menu;
  }

  if (data) {
    dataContent = data;
    if(data?.event?.workshops != undefined && data?.event?.workshops != null && data?.event?.workshops != '') {
      let form_login = data?.event?.workshops?.form_login;
      let form_loyalty = data?.event?.workshops?.form_loyalty;
      const baseUrl = process.env.NEXT_PUBLIC_DATA_BASEURL.replace("api", "themall_workshop");
      const resWorkshops = await fetch(baseUrl + '/services_list?ids=' + data?.event?.workshops.workshops_ids + '&lang=' + context.query.locale);
      const workshops = await resWorkshops.json();
      dataContent.event['workshops'] = workshops;
      dataContent.event['form_login'] = form_login;
      dataContent.event['form_loyalty'] = form_loyalty;
    }
  }
  //console.log('dataContent', dataContent);

  return {
    menuItems: menuItems,
    dataContent: dataContent,
    slug: slug,
    properties: resproperties
  };
};

export default EventDetailPage;
